var map = {
	"./AQUACULTURE_STEWARDSHIP_COUNCIL.jpg": 66141,
	"./ECOCERT_COSMOS_NATURAL.jpg": 74811,
	"./ECOCERT_COSMOS_ORGANIC.jpg": 33176,
	"./EUROPEAN_V_LABEL_VEGAN.jpg": 79547,
	"./EU_ORGANIC_FARMING.jpg": 64777,
	"./FAIR_TRADE_MARK.jpg": 49714,
	"./FALKEN.jpg": 74989,
	"./FRAN_SVERIGE.jpg": 45046,
	"./KOTT_FRAN_SVERIGE.jpg": 56414,
	"./KRAV_MARK.jpg": 90722,
	"./MARINE_STEWARDSHIP_COUNCIL_LABEL.jpg": 2075,
	"./MJOLK_FRAN_SVERIGE.jpg": 78818,
	"./NYCKELHALET.jpg": 76515,
	"./RAINFOREST_ALLIANCE.jpg": 25943,
	"./SVANEN.jpg": 68599,
	"./SVENSKT_SIGILL_KLIMATCERTIFIERAD.jpg": 74169,
	"./SVENSKT_SIGILL_NATURBETESKOTT.jpg": 76548,
	"./SVENSK_FAGEL.jpg": 60268,
	"./SWEDISH_SEAL_OF_QUALITY.jpg": 57888,
	"./UHM.jpg": 58667,
	"./UTZ_CERTIFIED.jpg": 94068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35387;